<template>
  <div class="list">
    <BaseArticle_row_card :arc_title="arc_title" :content="content" />
  </div>
</template>

<script>
import {inject, ref, watch} from "vue";
import axios from "axios";
import {useRoute} from "vue-router";
import arc_row from '../model/arc_row.vue';

export default {
  name: 'ArticleRow',
  setup(){

    const route = useRoute();
    var api_url=inject('api_url');
    const arc_title=ref("");
    const content=ref("");

    watch(() => route.params, () => {
      axios.get(api_url+"article_row?id="+route.params.id)
          .then(response => {
            if(response.data.status===1)
            {
              arc_title.value=response.data.data.post_title;
              content.value=response.data.data.post_content;
            }
          })
          .catch(error => {
            console.error('There was an error!', error);
          });
    }, { immediate: true });
    return {
      arc_title,content
    }
  },
  components: {
    BaseArticle_row_card: arc_row,
  }
}
</script>


